import { actions as awardsActions } from 'platform-components/src/components/awards/actions';
import qs from 'query-string';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';
import { useLifecycles } from 'react-use';

import lessonActions from 'common.components/lesson/actions';
import {
    getLesson,
    getLessonAssignmentDate,
    getLessonBanner,
    getLessonDeadlineDate,
} from 'common.components/lesson/selectors';
import {
    SPEC_COURSE_LESSON_MODE,
    SPEC_COURSE_LESSON_VIEW_DEFAULT_TAB,
} from 'common.components/spec-course-lesson-view/typings';
import { getLessonName } from 'utils/lesson';

import { SpecCourseHeader } from '../spec-course.header/header';
import { getSpecCourseLessonStatus } from '../spec-course.lessons-page/selectors';
import { specCourseActions } from '../spec-course.store/actions';
import * as specCourseSelectors from '../spec-course.store/selectors';

import { SpecCourseLessonView } from './lesson-view';
import { getSpecCourseLessonMode } from './selectors';

interface ParamType {
    classId: string;
    clessonId: string;
    courseId: string;
}

export const SpecCourseLessonViewContainer = () => {
    const { courseId: strCourseId, clessonId: strClessonId, classId: strClassId } = useParams<ParamType>();
    const dispatch = useDispatch();
    const { search } = useLocation();
    const history = useHistory();
    const lesson = useSelector(getLesson);
    const tabSlug = useSelector(specCourseSelectors.getTab);
    const beginDate = useSelector(getLessonAssignmentDate);
    const endDate = useSelector(getLessonDeadlineDate);
    const name = lesson && getLessonName(lesson);
    const banner = useSelector(getLessonBanner);
    const bannerSrc = (banner?.background_img || [])[0];
    const status = useSelector(getSpecCourseLessonStatus);

    const courseId = Number(strCourseId);
    const clessonId = Number(strClessonId);
    const classId = Number(strClassId);

    const mode = useSelector((store) => getSpecCourseLessonMode(store, { classId }));
    const campaignSlugs = useSelector((store) => specCourseSelectors.getStudentsAwardsCampaignSlugs(store));

    useLifecycles(
        () => {
            const { lessonId, ...restSearchParams } = qs.parse(search);

            if (clessonId && courseId && !lesson) {
                dispatch(lessonActions.getClessonWithResultsRequest({ clessonId, courseId }));
            }

            if (lessonId) {
                history.replace({
                    search: qs.stringify(restSearchParams, { arrayFormat: 'bracket' }),
                });
            }
        },
        () => {
            dispatch(specCourseActions.setTab({ tab: SPEC_COURSE_LESSON_VIEW_DEFAULT_TAB }));
        }
    );

    useEffect(() => {
        const shouldRequestAwards =
            mode === SPEC_COURSE_LESSON_MODE.LESSON_FINISHED || mode === SPEC_COURSE_LESSON_MODE.CONTROL_WORK_FINISHED;

        if (shouldRequestAwards) {
            dispatch(
                awardsActions.getMyAvailableAwards({
                    clessonId,
                })
            );

            if (campaignSlugs.length) {
                dispatch(
                    awardsActions.getStudentsAvailableAwards({
                        courseId,
                        campaignSlugs,
                    })
                );
            }
        }

        return () => {
            dispatch(awardsActions.clearAwards());
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode]);

    return (
        <div className="spec-course-lesson">
            <SpecCourseHeader />
            <SpecCourseLessonView
                bannerSrc={bannerSrc}
                beginDate={beginDate ? new Date(beginDate) : null}
                endDate={endDate ? new Date(endDate) : null}
                isSkeleton={!lesson}
                mode={mode}
                name={name}
                status={status}
                tabSlug={tabSlug}
            />
        </div>
    );
};
